<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="bp-button" mat-dialog-close >Cancel</button>
  <button mat-button class="bp-button" [mat-dialog-close]="true">{{ data.action }}</button>
</mat-dialog-actions>
